export const environment = {
  production: false,
  //legacyAuthenticationEnabled: true,
  // LOCAL TEST: local REM backend API.
  //apiUrl: 'http://localhost:5216/api',
  apiUrl: 'https://269wzpg3n9.execute-api.eu-central-1.amazonaws.com/api', //'http://localhost:5216/api',
  debugLogging: true,
  allowedUploadFileTypes: '.pdf, .xlsx, .png, .jpg, .jpeg, .zip, .heic, .heif, .gif, .bmp, .tiff, .webp, .dng, .svg, .csv, .txt',
  maxUploadFileSizeBytes: 4.5 * 1024 * 1024,
  maxNrUploadedFiles: 10,
  totalSizeUploadedFiles: 4.5 * 1024 * 1024,
  pageSize: 15,
  postLogoutUrl: 'https://dev.globaliamportal.com',
  cognito: {
    // LOCAL: use a Cognito app client whose callback and logout URLs include localhost.
    domain: 'dibmw-dev-dealer-auth.auth.eu-central-1.amazoncognito.com',
    clientId: 'sihi7fegrkj4fdgkp82lbc3dr', //'REM_APP_CLIENT_ID',
    redirectUri: 'https://dev.mra.globaliamportal.com/auth/callback', //'http://localhost:4200/auth/callback',
    logoutUri: 'https://dev.mra.globaliamportal.com/', //'http://localhost:4200/',
    scopes: ['openid', 'profile', 'rem/api']
  },
  "cognito_NSC": {
    domain: 'bmw-rem-frontend-dev-nsc.auth.eu-central-1.amazoncognito.com',
    clientId: '3h72bfnun7cmkae02ei6o7m01j', //'REM_APP_CLIENT_ID',
    redirectUri: 'https://dev.mra.globaliamportal.com/auth/callback', //'http://localhost:4200/auth/callback',
    logoutUri: 'https://dev.mra.globaliamportal.com/nsc',
    scopes: ['openid', 'profile', 'rem/api']
  }
};
